<template>
  <div id="notification-box">
    <div class="direct-chat-msg right">
    <div class="direct-chat-info clearfix">
      <span class="direct-chat-name pull-right" v-html="msg"></span>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      type: String,
    },
  },
  mounted() {
    console.log(this.msg);
  },
};
</script>

<style lang="scss" scoped>

.direct-chat-msg {
    border-radius: 5px;
    position: relative;
    padding: 5px 10px;
    background: #fff4f6;
    border: 1px solid #d2dbde;
    color: rgb(39, 39, 39);
    border-radius: 15px 15px 0 15px;
    margin: 5px 0 0 50px;
}
#notification-box{
  position: fixed;
  bottom: 20px;
  right: 10px;
  z-index: 1;
}
</style>
